import { RadioGroup } from '@vkontakte/vkui';
import React from 'react';
import type { Product } from 'reactApp/types/Billing';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import type { TariffByModalTab } from 'reactApp/ui/TariffsModal/TariffsModalContent.types';
import { TariffCardMobile } from 'reactApp/ui/TariffsModalMobile/TariffCardMobile/TariffCardMobile';

import styles from './TariffsListMobile.css';

interface TariffsListMobileProps {
    activeTab: ETabsName;
    tariffs: TariffByModalTab[];
    onRowClick: (tariff: TariffByModalTab, product: Product) => void;
    setTariff: (tariff: TariffByModalTab) => void;
    setProduct: (product: Product) => void;
    dataQa?: string;
}

export const TariffsListMobile = ({ tariffs, activeTab, setTariff, onRowClick, setProduct, dataQa }: TariffsListMobileProps) => {
    const groupName = 'tariff-list';

    const hasRecommended = tariffs.some((tariff) => tariff.isRecommended);

    return (
        <RadioGroup className={styles.radioGroup}>
            {tariffs.map((tariff, index) => (
                <div data-qa-id={`${dataQa}-${index}`} key={`tariff-list-${index}`}>
                    <TariffCardMobile
                        tariff={tariff}
                        activeTab={activeTab}
                        setTariff={setTariff}
                        setProduct={setProduct}
                        groupName={groupName}
                        index={index}
                        hasRecommended={hasRecommended}
                        onRowClick={onRowClick}
                        dataQa={`${dataQa}-${index}`}
                    />
                </div>
            ))}
        </RadioGroup>
    );
};
